import React, { useEffect } from 'react';
import { Route } from 'react-router-dom';

import PageHeader from '../../components/layout/PageHeader';
import PageFooter from '../../components/layout/PageFooter';
import cottonFlagManager from '../../helpers/featureFlags/cotton';
import { kibanaLog } from '../../helpers/logger';

/**
 * @param {{ pathname: string }} props Current payments route pathname.
 * @returns {null}
 */
const PageEnvironmentLog = ({ pathname }) => {
  useEffect(() => {
    kibanaLog('Cotton Cookie Details', {
      // 'not_set' distinguishes a missing cookie from one set to an empty value
      cotton_cookie_value: cottonFlagManager.cottonCookieValue ?? 'not_set',
      cotton_enabled: cottonFlagManager.isCottonEnabled,
    });
  }, [pathname]);

  return null;
};

const DefaultLayout = ({
  component: Component,
  isHarness,
  device,
  ...props
}) => (
  <Route
    {...props}
    render={matchProps => (
      <>
        <PageEnvironmentLog pathname={matchProps.location.pathname} />
        <PageHeader isHarness={isHarness} {...matchProps} />
        <main id="page-main" className="page-main" tabIndex="-1" role="main">
          <Component isHarness={isHarness} {...matchProps} {...props} />
        </main>
        <PageFooter />
      </>
    )}
  />
);

export default DefaultLayout;
